// 全局注册组件
import Vue from 'vue';

const requireComponent = require.context(
    // 组件目录的相对路径
    './',
    // 是否查询其子目录
    false,
    // 匹配组件文件名
    /[A-Z]\w+\.(vue|js)$/
);
requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);
    // 提取组件名
    const componentName = /.\/(.*?).vue/g.exec(fileName)[1];
    // 全局注册组件
    Vue.component(
        componentName,
        // 如果这个组件选项是通过 `export default` 导出的，
        componentConfig.default || componentConfig
    );
});
